<template>
  <div>
    <v-dialog :value="value" persistent @input="$emit('input', $event)">
      <v-card>
        <v-card-title>Do you want to receive notification from {{ brandName }}?</v-card-title>

        <v-card-actions>
          <v-btn @click="submit" :style="{ backgroundColor: btnBgColor }">Yes</v-btn>
          <v-btn @click="cancel" :style="{ backgroundColor: btnBgColor }">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar timeout="2000" bottom color="error" class="snackbar_error" v-model="snackbar">
      Notification is disabled in settings
    </v-snackbar>
  </div>
</template>

<script>
import NotificationService from '../services/notification.service';

const notificationService = new NotificationService();

export default {
  name: "NotificationsPrompt",
  props: {
    value: Boolean,
  },
  data() {
    return {
      snackbar: false,
    };
  },
  computed: {
    brandName() {
      return this.$store.getters['theme/brandName'];
    },
    btnBgColor() {
      return this.$store.getters['theme/btnBgColor'];
    }
  },
  methods: {
    async submit() {
      notificationService.askPermission().catch(() => {
        this.snackbar = true;
      });

      this.$emit('input', false);
    },
    cancel() {
      this.$emit('input', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card__title {
  font-size: 1rem !important;
  font-weight: 400 !important;
  padding: 16px 24px 10px !important;
  line-height: 1.5rem !important;
}
.v-card__actions {
  padding: 8px 24px 24px 24px !important;
}
</style>